import React from 'react';
import { NewModal } from 'lib/components';
import { Flex, Gap } from 'lib/components/styles/layout';
import { Button } from 'react-covideo-common';
import { useDeleteBackgroundMutation } from 'lib/api/backgrounds/useDeleteBackgroundMutation';
import { IBackgroundResponse } from 'lib/api/backgrounds/useQueryBackgrounds';
import { Trans, useTranslation } from 'react-i18next';

interface DeleteBackgroundModalProps {
  background: IBackgroundResponse;
  onClose: () => void;
}

export const DeleteBackgroundModal = ({
  background,
  onClose,
}: DeleteBackgroundModalProps) => {
  const { t } = useTranslation();
  const { mutateAsync: deleteBackgroundMutation, isLoading: isDeleting } =
    useDeleteBackgroundMutation(onClose);

  const onDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    deleteBackgroundMutation({ id: background.backgroundId });
  };

  return (
    <NewModal
      headerText={t('Delete Background')}
      closeModal={onClose}
      style={{
        content: { width: 592, maxWidth: 592 },
      }}
    >
      <Flex flexDirection='column' gap='20px'>
        <div>
          <Trans
            i18nKey='backgroundDeleteConfirmation'
            values={{ fileName: background.fileName }}
          />
        </div>
        <Gap gap='8px' justifyContent='flex-end'>
          <Button
            text={t('Cancel')}
            onClick={onClose}
            variant='secondary'
            disabled={isDeleting}
          />
          <Button
            text={t('Delete')}
            onClick={onDelete}
            variant='destructive'
            loading={isDeleting}
          />
        </Gap>
      </Flex>
    </NewModal>
  );
};
